import { Color } from '@cobalt/cobalt-react-components'

export const SETTINGS_CARD_BACKGROUND_COLOR = Color.background.gray[100]
